import { Typography } from "@mui/material";
import { DataGridPremium, useGridApiRef } from "@mui/x-data-grid-premium";
import { IAttachment, IAttachmentExtendedRecord } from "@shared/mirage/core/contracts/IAttachment";
import "./documentsTable.css";
import { DocumentsTableFileSizeCell } from "./DocumentsTableFileSizeCell";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import DateFormatter from "@shared/mirage/helpers/DateFormatter";
import { DocumentsTableActionCell } from "./DocumentsTableActionsCell";
import LocalAttachmentsService from "@mirage/services/LocalAttachmentsService";
import { SetStateAction } from "react";

export interface DocumentsHistoryPanelProps {
    row: IAttachment;
    service: LocalAttachmentsService;
    publicOnly: boolean;
    setRequestedPdfUrl: React.Dispatch<SetStateAction<string>>;
    onListChanged: () => void;
    readOnly?: boolean;
}
export const DocumentsHistoryPanel = (props: DocumentsHistoryPanelProps) => {
    const apiRef = useGridApiRef();
    if (!props.row.history) {
        return null;
    }
    const labelMap = new Map<number, string>();
    let index = 0;
    for (const att of props.row.history) {
        index++;
        const revIndex = props.row.history.length - index;
        if (revIndex === 0) {
            labelMap.set(att.id, "Original");
        } else {
            labelMap.set(att.id, "Revision " + revIndex);
        }
    }
    function renderName(p: GridRenderCellParams<IAttachment, any, any>, labelMap: Map<number, string>) {
        const attachment = p.row as IAttachmentExtendedRecord;
        const revisionText = labelMap.get(p.row.id);
        return (
            <span>
                <b>{p.value}</b>
                {` ${revisionText} made at ${DateFormatter.formatToDateTimeAmPm(attachment.createdTime)} by ${attachment.createdByUserId_relatedRecord?.name}`}
            </span>
        );
    }

    return (
        <>
            <div className="documentsHistory">
                <Typography>History</Typography>
                <DataGridPremium
                    apiRef={apiRef}
                    style={{ height: "250px" }}
                    rows={props.row.history}
                    columns={[
                        {
                            headerName: "Actions",
                            renderCell: (p) => {
                                return (
                                    <DocumentsTableActionCell
                                        readOnly={props.readOnly || false}
                                        service={props.service}
                                        publicOnly={props.publicOnly}
                                        row={p.row}
                                        setRequestedPdfUrl={props.setRequestedPdfUrl}
                                        onListChanged={() => {
                                            props.onListChanged();
                                        }}
                                    />
                                );
                            },
                            field: "",
                            width: 250,
                        },
                        { field: "name", headerName: "File name", renderCell: (p) => renderName(p, labelMap), flex: 50 },
                        { field: "bodyLength", headerName: "Size", renderCell: (p) => <DocumentsTableFileSizeCell val={p.value} />, flex: 50 },
                    ]}
                    rowHeight={38}
                    disableRowSelectionOnClick
                ></DataGridPremium>
            </div>
        </>
    );
};
